// Bê từ finiva-admin settings/services/settings.service.ts. Sửa: chỉ còn tùy chọn hiển thị (bỏ thông báo, tập đoàn, push)
import { apiClient } from '@lib/api-client'
import type { AccountPreferences } from '../types'

const opts = { withCredentials: true }

export const settingsService = {
  async preferences(): Promise<AccountPreferences> {
    return (await apiClient.get<AccountPreferences>('/me/preferences', opts)).data
  },
  async savePreferences(p: AccountPreferences): Promise<AccountPreferences> {
    return (await apiClient.put<AccountPreferences>('/me/preferences', p, opts)).data
  },
}
